import { getCdnBaseUrl } from '@/config/env-config';

const PLAY_STORE_BADGE_PATH = '/icons/google-play-badge.svg';
const APP_STORE_BADGE_PATH = '/icons/app-store-badge.svg';
const NEWCORE_APP_ICON_PATH = '/icons/newcore_app_icon.svg';

export function getPlayStoreBadgeUrl() {
  return `${getCdnBaseUrl()}${PLAY_STORE_BADGE_PATH}`;
}

export function getAppStoreBadgeUrl() {
  return `${getCdnBaseUrl()}${APP_STORE_BADGE_PATH}`;
}

export function getNewcoreAppIconUrl() {
  return `${getCdnBaseUrl()}${NEWCORE_APP_ICON_PATH}`;
}
